import {
  inject, observer,
} from 'mobx-react';
import {
  WithSnackbarProps,
} from 'notistack';
import React, {
  Component,
} from 'react';
import GeneralTableComponent from '../../components/GeneralCRUDComponent/GeneralTableComponent/GeneralTableComponent';
import {
  TableCellTypes,
} from '../../components/GeneralCRUDComponent/TableCellTypes/TableCellTypes';
import SnackBarComponent from '../../components/SnackBarComponent/SnackBarComponent';
import {
  translate,
} from '../../helperFunctions/translation';
import {
  IBannerAdsStore,
} from '../../mobx-store/storeInterfaces/bannerAdsInterface';
import {
  AuthStore,
} from '../../mobx-store/stores/authStore';
import {
  CountryStore,
} from '../../mobx-store/stores/countryStore';
import {
  entityTypeValues,
} from '../addEditAdsScreen/addEditAds';

interface IProps extends WithSnackbarProps {
  bannerAdsStore: IBannerAdsStore;
  countryStore: CountryStore;
  authStore: AuthStore;
  history: any;
}

interface State {
  notify: boolean;
  currentElement: number;
}

@inject('bannerAdsStore')
@inject('countryStore')
@inject('authStore')
@observer
class BannerAds extends Component<IProps, State> {
  addButton: any;

  tableHeader: any = [];

  tableData: any[] = [];

  tableCellTypes: TableCellTypes[] = [];

  title: string;

  isSports = false;

  isMarketing = false;

  All_ALLOWED_ENTITY_TYPES: entityTypeValues[] = [
    entityTypeValues.sports,
    entityTypeValues.offers,
    entityTypeValues.partners,
    entityTypeValues.trophies,
    entityTypeValues.academies,
    entityTypeValues.branches,
    entityTypeValues.referral,
    entityTypeValues.renewal,
  ];

  Marketing_ALLOWED_ENTITY_TYPES: entityTypeValues[] = [
    entityTypeValues.offers,
    entityTypeValues.partners,
    entityTypeValues.trophies,
    entityTypeValues.academies,
    entityTypeValues.branches,
    entityTypeValues.referral,
    entityTypeValues.renewal,
  ];

  constructor(props: IProps) {
    super(props);
    this.title = translate('bannerAdsListPageTitle', {
    });
    this.state = {
      notify: false,
      currentElement: 0,
    };
  }

  handleCloseModal = () => {
    this.setState({
      notify: false,
    });
  };

  disableStatus = (index: number) => !this.props.bannerAdsStore.adsList[index].isPublished;

  handleTableButtonCellClicked = (index: number, key: string) => {
    this.props.history.push(`/banner-ads/${this.props.bannerAdsStore.adsList[index].adId}/edit`);
  };

  handleTableToggleCellChange = (index: number, key: string, value: boolean) => {
    this.props.bannerAdsStore.updateAdStatus(value, index)
      .then(() => {
        SnackBarComponent.getInstance().openSnackbar(translate('updatedMessage', {
        }), 8000, 'success');
      })
      .catch((error: any) => {
        SnackBarComponent.getInstance().openSnackbar(translate('errorMessage', {
        }), 8000, 'error');
      });
  };

  handelAdd = (): void => {
    this.props.history.push('/banner-ads/new');
  };

  getAddAdButton = () => ({
    title: translate('bannerAdsListAddButton', {
    }),
    onAdd: this.handelAdd,
  });

  getAdsTableHeader = () => [
    {
      title: translate('bannerAdsListTitleColumnTitle', {
      }),
    },
    {
      title: translate('bannerAdsListStatusColumnTitle', {
      }),
    },
    {
      title: translate('bannerAdsStartDateTitle', {
      }),
    },
    {
      title: translate('bannerAdsEndtDateTitle', {
      }),
    },
    {
      title: 'Edit',
    },
  ];

  getAdsTableData = () => this.props.bannerAdsStore.adsList
    .map((ad) => ({
      ...ad,
      edit: 'Edit',
      notification: translate('bannerAdsListNotificationColumnTitle', {
      }),
    }));

  getAdsTableCellTypes = (): TableCellTypes[] => [
    {
      cellType: 'Text',
      key: 'title',
    },
    {
      cellType: 'ToggleButton',
      key: 'isPublished',
      activeLabel: translate('addArticlePageFormStatusPublishedLabel', {
      }),
      inactiveLabel: translate('addArticlePageFormStatusUnpublishedLabel', {
      }),
      onChange: this.handleTableToggleCellChange,
    },
    {
      cellType: 'Text',
      key: 'startDate',
    },
    {
      cellType: 'Text',
      key: 'endDate',
    },
    {
      cellType: 'Button',
      key: 'edit',
      onClick: this.handleTableButtonCellClicked,
    },
  ];

  render() {
    this.addButton = this.getAddAdButton();
    this.tableHeader = this.getAdsTableHeader();
    this.tableData = this.getAdsTableData();
    this.tableCellTypes = this.getAdsTableCellTypes();
    return (
      <div>
        <GeneralTableComponent
          emptyMessage={translate('bannerAdsListNoAdsMessage', {
          })}
          title={this.title}
          tableHeader={this.tableHeader}
          tableData={this.tableData}
          tableCellTypes={this.tableCellTypes}
          addButton={this.addButton}
          loadingStatus={[
            this.props.bannerAdsStore.getAdsRequestStatus,
            this.props.countryStore.getManagedCountriesRequestStatus
          ]}
        />
      </div>
    );
  }

  async componentDidMount() {
    const {
      countryStore, bannerAdsStore, authStore,
    } = this.props;
    const {
      userData,
    } = authStore;
    const {
      title,
    } = userData.role;
    this.isSports = title === 'sports';
    this.isMarketing = title === 'marketing';

    const entityType = this.isSports ? [entityTypeValues.sports] : (this.isMarketing ? this.Marketing_ALLOWED_ENTITY_TYPES : null);
    await countryStore.getUserManagedCountries();

    bannerAdsStore.getAds(countryStore.managedCountries, entityType);
  }
}

export default BannerAds;
